// api/contactSales.js

export const sendContactSalesEmail = async (formData) => {
    try {
      const response = await fetch('https://zoomlogi.com/contactsales', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      if (!response.ok) {
        const result = await response.json();
        throw new Error(result.error || 'Failed to send your message.');
      }
  
      return { success: true, message: 'Your message has been sent successfully!' };
    } catch (error) {
      console.error('Error:', error);
      return { success: false, message: error.message || 'An error occurred while sending your message.' };
    }
  };
  